<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-shipindiaoyue`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_546bdbd488__clip0_1240_275203)" fill-rule="evenodd" clip-rule="evenodd"><path d="M3 13.125V4.875H11.625V9.59898C12.0862 9.34959 12.591 9.17056 13.125 9.0763V7.30802L15.375 6.63302V9.19144C15.9185 9.34655 16.4242 9.59132 16.875 9.90872V6.12901C16.875 5.37542 16.1485 4.83491 15.4267 5.05146L13.125 5.74198V4.5C13.125 3.87868 12.6213 3.375 12 3.375H2.625C2.00368 3.375 1.5 3.87868 1.5 4.5V13.5C1.5 14.1213 2.00368 14.625 2.625 14.625H9.03868C9.01315 14.4203 9 14.2117 9 14C9 13.7015 9.02616 13.4091 9.0763 13.125H3ZM4.125 7.875H6.375V6.375H4.125V7.875Z"/><path d="M18 14C18 16.2091 16.2091 18 14 18C11.7909 18 10 16.2091 10 14C10 11.7909 11.7909 10 14 10C16.2091 10 18 11.7909 18 14ZM11.5002 15C11.5002 14.7239 11.7241 14.5 12.0002 14.5H16.5C16.7761 14.5 17 14.7239 17 15C17 15.2761 16.7761 15.5 16.5 15.5H12.0002C11.7241 15.5 11.5002 15.2761 11.5002 15ZM12 12.5C11.7239 12.5 11.5 12.7239 11.5 13C11.5 13.2761 11.7239 13.5 12 13.5H14C14.2761 13.5 14.5 13.2761 14.5 13C14.5 12.7239 14.2761 12.5 14 12.5H12Z"/></g><defs><clipPath id="svg_546bdbd488__clip0_1240_275203"><path d="M0 0H18V18H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconShipindiaoyue',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
